import { render } from "./MenuGroups.vue?vue&type=template&id=376ed858"
import script from "./MenuGroups.vue?vue&type=script&lang=js"
export * from "./MenuGroups.vue?vue&type=script&lang=js"
script.render = render

export default script